import Vue from 'vue'
import VueRouter, {Route, RouteConfig} from 'vue-router'
import Home from '@/views/Home.vue'
import Table from '@/views/table/Table.vue'
import TablesList from '@/views/table/TablesList.vue'
import PublicPage from '@/views/PublicPage.vue'
import ForwardPage from '@/views/ForwardPage.vue'
import Settings from '@/views/Settings.vue'
import {checkCurrentUser} from '@/services/authentication'
import store from '../store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/Login.vue')
    },
    {
        path: '',
        component: PublicPage,
        meta: {action: ['loadSubscriptions']},
        children: [
            {
                path: '/',
                name: 'home',
                component: Home,
                meta: {action: ['hideLeftMenu']}
            },
            {
                path: '/settings',
                name: 'settings',
                component: Settings,
                meta: {action: ['hideLeftMenu']}
            },
            {
                path: '/table/show/:profile',
                name: 'tables',
                meta: {action: ['showLeftMenu']},
                components: {
                    leftMenu: TablesList
                },
                props: true
            },
            {
                path: '/table/show/:profile/:tableName',
                name: 'table',
                meta: {action: ['showLeftMenu']},
                components: {
                    default: Table,
                    leftMenu: TablesList
                },
                props: true
            },
            {
                path: '/profiles',
                meta: {action: ['hideLeftMenu']},
                component: ForwardPage,
                props: true,
                children: [
                    {
                        path: 'create',
                        name: 'profile-create',
                        component: () => import('../views/profiles/EditProfile.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'profile-edit',
                        props: true,
                        component: () => import('../views/profiles/EditProfile.vue')
                    }
                ]
            }
        ]
    }
]

const router = new VueRouter({
    routes
})

const publicToAccess = ['login']
// no subscription required
const freeToAccess = ['settings']

router.beforeEach(async (to, from, next) => {
    if (to.name && publicToAccess.includes(to.name)) {
        next()
        return
    }

    try {
        const userSession = await checkCurrentUser()
        await store.dispatch('setUserSession', userSession)
        await executeActions(to)
        if (store.getters.hasActiveSubscriptions || (to.name && freeToAccess.includes(to.name))) {
            next()
        } else {
            next({name: 'settings'})
        }
    } catch (e) {
        next({name: 'login'})
    }
})

async function executeActions(to: Route) {
    return Promise.all(
        to.matched
            .filter(_ => _.meta && _.meta.action)
            .flatMap(_ => _.meta.action)
            .map(_ => store.dispatch(_, to.params))
    )
}

export default router
